export enum NavbarLinks {
    ABOUT_US = "about-us",
    SERVICES = "services",
    CLIENTS = "clients",
    BLOG = "blog",
}


export enum InquiryType {
    Startups = "Startups",
    Careers = "Careers", 
    Partnerships = "Partnerships",
    General = "General"
  }
